import styled from 'styled-components';
import {Input, Form} from 'global/styles/styles.js';

const S = {};

S.RegisterWizardFormStep1 = styled(Form)` 
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    background-color: ${({theme: {$registerFormBackgroundColor}}) => $registerFormBackgroundColor};
    padding: 1.1875rem;
    padding-bottom: 1.3rem;
`;

S.Row = styled.div`
    width: 100%;
`;

S.PasswordToggler = styled.div`
    position: absolute;
    right: 5%;
    top: 19px;
    height: 25px;
    width: 25px;
    font-size: 20px;
`;

S.PasswordTogglerIcon = styled.i``;

S.TextToggler = styled.span`
  align-self: flex-end;
`;


S.InputWrapper = styled.div`
    position: relative;
    padding: 0.625rem 0 0 0;
    width: 100%; 
    margin: 0 auto;
`;

S.CheckboxWrapper = styled.div`
    position: relative;
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    margin: 1.125rem 0 0 0;
    padding-left: 0;

    input {
        position: absolute!important;
        padding: 0!important;
        border: 0!important;
        overflow: hidden;
        z-index: 0;
        top: 0;
        height: 12px;
        width: auto;
        cursor:pointer;

        &:checked {
            & + div {
                background-color: #D32F2F;
                border-color: #D32F2F; 
            }
        }
    }

    label {
        color: ${({theme: {$registerFormLabelColor}}) => $registerFormLabelColor};
        font-size: 0.625rem;
        display: inline;
        text-align: left;
        position: relative;
        left: 0px;
        top: 0px;
        flex: 1 1 0%;
        line-height: 1.7;
        align-self: center;

        a {
            color: ${({theme: {$registerFormLinkColor}}) => $registerFormLinkColor};
            text-decoration: none;
        }

        span {
            :nth-of-type(2) {
                color: #D32F2F;
                font-weight: 700;
            } 
        }
    }
`;

S.Input = styled(Input)`
    border: 1px solid ${({theme: {$registerFormInputBorderColor}}) => $registerFormInputBorderColor};
    border-radius: 3px;
    background-color: ${({theme: {$registerFormInputBackgroundColor}}) => $registerFormInputBackgroundColor};
    height: 42px;
    color: ${({theme: {$registerFormInputColor}}) => $registerFormInputColor};
    font-size: 0.875rem;
    box-sizing: border-box;
    width: 100%;
    padding: 0px 1.33333rem;




    &:valid {
        & + label {
         color: rgba(0, 0, 0, 0.5);
         margin-top: -1.3125rem;
         font-size: 0.625rem;
        }
     }

    &:focus {
        outline: 0;
    }

    &.is-valid {
        border: 2px solid rgb(99, 221, 125);

        & + label {
          color: #63dd7d;
        }
    }

    &.has-error {
        border: 2px solid #D32F2F;

        & + label {
            color: #D32F2F;
        }
    }
`;

S.FakeChbox = styled.div`
    width: 18px;
    height: 18px;
    border: 1px solid #EFF1F2;
    border-radius: 0;
    margin-right:  10px;
    cursor: pointer;
    margin-top: -2px;
    flex-shrink: 0;
    z-index: 3;
    pointer-events: none;
    background-color: #fff;
    position: relative;
`;

S.CheckMark = styled.span`
    &:after {
        content: '\f00c';
        display:block;
        font-family: FontAwesome;
        position: absolute;
        left: 0;
        top: 0;
        color: #fff;
        font-size: 16px;
    }
`;

S.Label = styled.label`
    pointer-events: none;
    color: rgba(0, 0, 0, 54%);
    text-align: left;
    position: absolute;
    left: 10px;
    top: 24px;
    background-color: ${({theme: {$registerFormLabelBgColor}}) => $registerFormLabelBgColor};
    width: auto;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    font-weight: 500;
    transition: .2s;
`;

S.SubmitButton = styled.button`
    background-color: ${({theme: {$registerFormSubmitButtonBgColor}}) => $registerFormSubmitButtonBgColor};
    color: ${({theme: {$registerFormSubmitButtonColor}}) => $registerFormSubmitButtonColor};
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    border-radius: 3px;
    border: none;
    height: 2.625rem;

    &:disabled {
        background: #E1E5E6;
        color: #8F8F8F; 
    }
`;

S.Error = styled.div`
    color: #CE0006;
    margin: 0 auto;
    font-size: 10px;
    flex: 1 100%;
`;

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: #CE0006;
    font-size: 1rem;
    padding: .83rem;
    background-color: #fba59f;
    margin-bottom: .5rem;
    text-align: center;
`;

S.AdditionalInfo = styled.div`
    text-align: left;
    font-size: 0.625rem;
    color: #000;
    line-height: 1.7;
    margin: 1.5rem 0;
    font-weight: 500;
`;

export default S;